 <div class="text-sm" *ngIf="caseData$ | async as caseData">
  <div id="accordion">

    <div class="card mb-4">
      <div class="card-header p-0" id="headingOne">
        <h5 class="mb-0">
          <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
            aria-controls="collapseOne">
            Client Information
            <i class="fa fa-chevron-down arrow-icon"></i>
          </button>
        </h5>
      </div>

      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
        <div class="card-body m-3">
          <div class="row mb-3">

            <div class="col-4">
              <span>Case Type</span>
              <div>
                <span class="fw-500">{{ caseData?.clientInformation?.case_type?.name }}</span>
              </div>
            </div>

            <div class="col-4">
              <span>Client Name</span>
              <div>
                <span class="fw-500">{{ caseData?.clientInformation?.client?.name }}</span>
              </div>
            </div>

            <div class="col-4">
              <span>Program Name</span>
              <div>
                <span class="fw-500">Comprehensive Care Plan B</span>
              </div>
            </div>
          </div>

          <hr>

          <div class="row mb-3">
            <div class="col-4">
              <span>Location</span>
              <div>
                <span class="fw-500">San Diego, CA</span>
              </div>
            </div>

            <div class="col-4">
              <span>Primary Contact</span>
              <div>
                <span class="fw-500">David Mitchell</span>
              </div>
            </div>

            <div class="col-4">
              <span>Claim/Reference Number</span>
              <div>
                <span class="fw-500">{{ caseData?.clientInformation?.claim_reference_no }}</span>
              </div>
            </div>
          </div>

          <hr>

          <div class="row mb-3">
            <div class="col-4">
              <span>Companion File</span>
              <div>
                <span class="fw-500">{{ caseData?.clientInformation?.companion_file }}</span>
              </div>
            </div>

            <div class="col-4">
              <span>Case Services</span>
              <div>
                <span class="fw-500">{{ caseData?.clientInformation?.case_service?.length ? getCaseServiceNames(caseData.clientInformation.case_service) : '' }}</span>
              </div>
            </div>

            <div class="col-4">
              <span>Insured</span>
              <div>
                <span class="fw-500">{{ caseData?.clientInformation?.insured_date }}</span>
              </div>
            </div>
          </div>

          <hr>

          <div class="row">
            <div class="col-4">
              <span>DOL</span>
              <div>
                <span class="fw-500">{{ caseData?.clientInformation?.dol }}</span>
              </div>
            </div>

            <div class="col-4">
              <span>Policy Number</span>
              <div>
                <span class="fw-500">{{ caseData?.clientInformation?.policy_number }}</span>
              </div>
            </div>

            <div class="col-4">
              <span>Policy Period</span>
              <div>
                <span class="fw-500">{{ caseData?.clientInformation?.policy_period_from_date }} - {{ caseData?.clientInformation?.policy_period_to_date }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngFor="let location of caseData?.location_detail; let i = index">
      <div class="card mb-4">
        <div class="card-header p-0" id="heading{{ i }}">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" [attr.data-target]="'#collapse' + i" aria-expanded="false"
              aria-controls="collapseTwo">
              Location Details {{ i + 1 }}
              <i class="fa fa-chevron-down arrow-icon"></i>
            </button>
          </h5>
        </div>
        <div id="collapse{{ i }}" class="collapse" aria-labelledby="heading{{ i }}" data-parent="#accordion">
          <div class="card-body m-3">

            <div class="row mb-3">
              <div class="col-4">
                <span>Country</span>
                <div>
                  <span class="fw-500">{{ location?.country || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>State</span>
                <div>
                  <span class="fw-500">{{ location?.state?.name ? location?.state?.name || '--' : location?.state || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>City</span>
                <div>
                  <span class="fw-500">{{ location?.city || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">

              <div class="col-4">
                <span>County</span>
                <div>
                  <span class="fw-500">{{ location?.county || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Zipcode</span>
                <div>
                  <span class="fw-500">{{ location?.zip_code || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Address Line</span>
                <div>
                  <span class="fw-500">{{ location?.address_line || '--' }}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </ng-container>


    <ng-container *ngFor="let subject of caseData?.subject_detail; let j = index">
      <div class="card mb-4">
        <div class="card-header p-0" id="headingThree">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree"
              aria-expanded="false" aria-controls="collapseThree">
              Subject {{ j + 1 }} - {{ subject.type | humanizeText }}
              <i class="fa fa-chevron-down arrow-icon"></i>
            </button>
          </h5>
        </div>
        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">


          <div class="card-body m-3" *ngIf="subject.type == 'insured'">
            <div class="row mb-3">
              <div class="col-4">
                <span>Business Name</span>
                <div>
                  <span class="fw-500">{{ subject?.business_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>First Name</span>
                <div>
                  <span class="fw-500">{{ subject?.first_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Middle Name</span>
                <div>
                  <span class="fw-500">{{ subject?.middle_name || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">

              <div class="col-4">
                <span>Last Name</span>
                <div>
                  <span class="fw-500">{{ subject?.last_name || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Suffix</span>
                <div>
                  <span class="fw-500">{{ subject?.suffix || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>AKA</span>
                <div>
                  <span class="fw-500">{{ subject?.aka || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>Address</span>
                <div>
                  <span class="fw-500">{{ subject?.address_1 || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>City</span>
                <div>
                  <span class="fw-500">{{ subject?.city || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>State</span>
                <div>
                  <span class="fw-500">{{ subject?.state || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">

              <div class="col-4">
                <span>Main #</span>
                <div>
                  <span class="fw-500">{{ subject?.main_phone_number || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Cell #</span>
                <div>
                  <span class="fw-500">{{ subject?.cell_phone_number || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>DOB</span>
                <div>
                  <span class="fw-500">{{ subject?.dob || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">

              <div class="col-4">
                <span>SSN</span>
                <div>
                  <span class="fw-500">{{ subject?.ssn || '--' }}</span>
                </div>
              </div>
            </div>

          </div>

          <div class="card-body m-3" *ngIf="subject.type == 'claimant'">
            <div class="row mb-3">
              <div class="col-4">
                <span>First Name</span>
                <div>
                  <span class="fw-500">{{ subject?.first_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Middle Name</span>
                <div>
                  <span class="fw-500">{{ subject?.middle_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Last Name</span>
                <div>
                  <span class="fw-500">{{ subject?.last_name || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">


              <div class="col-4">
                <span>Suffix</span>
                <div>
                  <span class="fw-500">{{ subject?.suffix || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>AKA</span>
                <div>
                  <span class="fw-500">{{ subject?.aka || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Address</span>
                <div>
                  <span class="fw-500">{{ subject?.address_1 || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">

              <div class="col-4">
                <span>City</span>
                <div>
                  <span class="fw-500">{{ subject?.city || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>State</span>
                <div>
                  <span class="fw-500">{{ subject?.state || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Zip</span>
                <div>
                  <span class="fw-500">{{ subject?.zip || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">

              <div class="col-4">
                <span>Home #</span>
                <div>
                  <span class="fw-500">{{ subject?.home_phone_number || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Cell #</span>
                <div>
                  <span class="fw-500">{{ subject?.cell_phone_number || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Business #</span>
                <div>
                  <span class="fw-500">{{ subject?.business_phone_number || '--' }}</span>
                </div>
              </div>

            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>DOB</span>
                <div>
                  <span class="fw-500">{{ subject?.dob || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>SSN</span>
                <div>
                  <span class="fw-500">{{ subject?.ssn || '--' }}</span>
                </div>
              </div>
            </div>

          </div>

          <div class="card-body m-3" *ngIf="subject.type == 'defense_attorney' || subject.type == 'applicant_party_attorney'">
            <div class="row mb-3">
              <div class="col-4">
                <span>Firm Name</span>
                <div>
                  <span class="fw-500">{{ subject?.firm_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>First Name</span>
                <div>
                  <span class="fw-500">{{ subject?.first_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Middle Name</span>
                <div>
                  <span class="fw-500">{{ subject?.middle_name || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>Last Name</span>
                <div>
                  <span class="fw-500">{{ subject?.last_name || '--' }}</span>
                </div>
              </div>


              <div class="col-4">
                <span>Suffix</span>
                <div>
                  <span class="fw-500">{{ subject?.suffix || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>AKA</span>
                <div>
                  <span class="fw-500">{{ subject?.aka || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>Address</span>
                <div>
                  <span class="fw-500">{{ subject?.address_1 || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>City</span>
                <div>
                  <span class="fw-500">{{ subject?.city || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>State</span>
                <div>
                  <span class="fw-500">{{ subject?.state || '--' }}</span>
                </div>
              </div>

            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>Zip Code</span>
                <div>
                  <span class="fw-500">{{ subject?.zip || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Business #</span>
                <div>
                  <span class="fw-500">{{ subject?.business_phone_number || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Cell #</span>
                <div>
                  <span class="fw-500">{{ subject?.cell_phone_number || '--' }}</span>
                </div>
              </div>
            </div>

          </div>

          <div class="card-body m-3" *ngIf="subject.type == 'co_defendant'">
            <div class="row mb-3">
              <div class="col-4">
                <span>Role</span>
                <div>
                  <span class="fw-500">{{ subject?.role || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Company Name</span>
                <div>
                  <span class="fw-500">{{ subject?.company_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>First Name</span>
                <div>
                  <span class="fw-500">{{ subject?.first_name || '--' }}</span>
                </div>
              </div>

            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>Middle Name</span>
                <div>
                  <span class="fw-500">{{ subject?.middle_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Last Name</span>
                <div>
                  <span class="fw-500">{{ subject?.last_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Suffix</span>
                <div>
                  <span class="fw-500">{{ subject?.suffix || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>AKA</span>
                <div>
                  <span class="fw-500">{{ subject?.aka || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Address</span>
                <div>
                  <span class="fw-500">{{ subject?.address_1 || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>City</span>
                <div>
                  <span class="fw-500">{{ subject?.city || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">

              <div class="col-4">
                <span>State</span>
                <div>
                  <span class="fw-500">{{ subject?.state || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Zip Code</span>
                <div>
                  <span class="fw-500">{{ subject?.zip || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Home #</span>
                <div>
                  <span class="fw-500">{{ subject?.home_phone_number || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>Cell #</span>
                <div>
                  <span class="fw-500">{{ subject?.cell_phone_number || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Business #</span>
                <div>
                  <span class="fw-500">{{ subject?.business_phone_number || '--' }}</span>
                </div>
              </div>

            </div>

          </div>

          <div class="card-body m-3" *ngIf="subject.type == 'other'">
            <div class="row mb-3">
              <div class="col-4">
                <span>Role</span>
                <div>
                  <span class="fw-500">{{ subject?.role || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>First Name</span>
                <div>
                  <span class="fw-500">{{ subject?.first_name || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>Middle Name</span>
                <div>
                  <span class="fw-500">{{ subject?.middle_name || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>Last Name</span>
                <div>
                  <span class="fw-500">{{ subject?.last_name || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Suffix</span>
                <div>
                  <span class="fw-500">{{ subject?.suffix || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>AKA</span>
                <div>
                  <span class="fw-500">{{ subject?.aka || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>Address</span>
                <div>
                  <span class="fw-500">{{ subject?.address_1 || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>City</span>
                <div>
                  <span class="fw-500">{{ subject?.city || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>State</span>
                <div>
                  <span class="fw-500">{{ subject?.state || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-4">
                <span>Zip Code</span>
                <div>
                  <span class="fw-500">{{ subject?.zip || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Home #</span>
                <div>
                  <span class="fw-500">{{ subject?.home_phone_number || '--' }}</span>
                </div>
              </div>
              <div class="col-4">
                <span>Cell #</span>
                <div>
                  <span class="fw-500">{{ subject?.cell_phone_number || '--' }}</span>
                </div>
              </div>
            </div>

            <div class="row mb-3">

              <div class="col-4">
                <span>Business #</span>
                <div>
                  <span class="fw-500">{{ subject?.business_phone_number || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>DOB</span>
                <div>
                  <span class="fw-500">{{ subject?.dob || '--' }}</span>
                </div>
              </div>

              <div class="col-4">
                <span>SSN</span>
                <div>
                  <span class="fw-500">{{ subject?.ssn || '--' }}</span>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </ng-container>

  </div>
</div>